import axios from '../helpers/axios'
import { logError } from '../services';
import { IPlanStyleRes } from '../models';

export const getPlanStyles = async (filters?: { name?: string; sortBy?: string; sortDirection?: string; page?: number; perPage?: number }): Promise<IPlanStyleRes> => {
  try {
    const { data } = await axios.get(`/api/planstyles`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getPlanStyles failed');
    return Promise.reject(error);
  }
};

export const addPlanStyle = async (post: { name: string; sageDescription: string; description?: string }): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/planstyles`, post);
    return data;
  } catch (error) {
    logError({ error, payload: post }, 'addPlanStyle failed');
    return Promise.reject(error);
  }
};

export const deletePlanStyle = async (planStyleId: number): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/planstyles/${planStyleId}`);
    return data;
  } catch (error) {
    logError(error, 'deletePlanStyle failed');
    return Promise.reject(error);
  }
};
